import moment from "moment-timezone";
import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { CustomerReview } from "@shared/graphql";
import { DataProps } from "../../tools/components";
import { ModalHandler, Overlay } from "../layout/overlays";
import ReviewCard from "../review-card";
import "./reviews-into-modal.scss";

const transDefs = defineMessages({
  title: { id: "article.rubrics.reviews.modal-title", defaultMessage: "Commentaires clients" },
  answer: { id: "article.rubrics.reviews.answer", defaultMessage: "Réponse" }
});

export type ReviewsHandler = {
  display: (index: number) => void;
}

const ReviewsIntoModal = forwardRef<ReviewsHandler, DataProps<CustomerReview[]>>(({ data }, forwardedRef) => {

  const intl = useIntl();

  const ref = useRef<ModalHandler>(null);
  const [ open, setOpen ] = useState(false);

  useImperativeHandle(forwardedRef, () => ({
    display: index => {
      setOpen(true);
      ref.current?.scrollToAnchor(`comment-${index}`);
    }
  }));

  const formatDate = useCallback((value: string) =>  {
    const date = moment(value);
    return date.isValid() ? intl.formatDate(date.toDate(), { year: "numeric", month: "long" }) : value;
  }, [ intl ]);

  return (
    <Overlay.Modal ref={ref} size="lg"
                   {...{ open, setOpen } }>
      <Overlay.ModalContent title={intl.formatMessage(transDefs.title)}
                            className="full-reviews">
        {data.map((item, index) => (
          <div key={index} id={`comment-${index}`} className="single-review">
            <ReviewCard loading={false} data={item} fullDisplay={true} />
            {!!item.answer &&
              <div className="answer">
                <div className="agency">
                  <span>{intl.formatMessage(transDefs.answer)}</span>
                  {formatDate(item.answer.answeredAt)}
                </div>
                <p className="comment">{item.answer.comment}</p>
              </div>
            }
          </div>)
        )}
      </Overlay.ModalContent>
    </Overlay.Modal>);

});

export default ReviewsIntoModal
